<template>
  <div  class="sign-list">
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem>签到管理</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <h2>{{ meeting.title }}</h2>
      <Card style="margin-bottom: 20px">
        <p slot="title">
          <Icon type="log-in"></Icon>
          扫码签到
        </p>
        <div style="text-align: center" class="sign-in-card">
          <Input size="large" style="width: 300px; height: 50px;" v-model.trim="signCode" @on-enter="signInWithCode" placeholder="签到码" autofocus></Input>
          <Button type="success" size="large" @click="signInWithCode" icon="log-in" style="margin-left: 10px">签到</Button>
        </div>
      </Card>
      <Card style="min-height: 600px">
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          签到列表
        </p>
        <a slot="extra" :href="`/api/admin/meetings/${meetingId}/signAttendees/signIn/export`"><Icon type="ios-download-outline"></Icon> 导出签到表</a>
        <p>
          <Form ref="formValidate" inline>
            <FormItem>
              <Input v-model.trim="searchCompanyName" clearable @on-enter="search()">
              <span slot="prepend">公司名称</span>
              </Input>
            </FormItem>
            <FormItem>
              <Input v-model.trim="searchPersonName" clearable @on-enter="search()">
              <span slot="prepend">姓名</span>
              </Input>
            </FormItem>
            <FormItem>
              <Input v-model.trim="searchMobile" clearable @on-enter="search()">
              <span slot="prepend">手机</span>
              </Input>
            </FormItem>
            <FormItem>
              <Input v-model.trim="searchEmail" clearable @on-enter="search()">
              <span slot="prepend">邮箱</span>
              </Input>
            </FormItem>
            <FormItem>
              <Button type="primary" shape="circle" icon="ios-search" @click="search()">搜索</Button>
            </FormItem>
          </Form>
        </p>
        <p>
          <ButtonGroup>
            <Button icon="ios-search" :type="showingHasSignIn === false ? 'primary' : 'default'" @click="showingHasSignIn = false">未签到（<span :style="{color: countWaitSignIn > 0 ? 'red' : 'inherit'}">{{ countWaitSignIn }}</span>）</Button>
            <Button icon="ios-search" :type="showingHasSignIn === undefined ? 'primary' : 'default'" @click="showingHasSignIn = undefined">全部（{{ countAll }}）</Button>
            <Button icon="ios-search" :type="showingHasSignIn === true ? 'primary' : 'default'" @click="showingHasSignIn = true">已签到（{{ countSignedIn }}）</Button>
          </ButtonGroup>
        </p>
        <Table :columns="columns" :data="rows" :show-header="true" ref="table"></Table>
      </Card>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'SignIn',
  props: ['meetingId'],
  data () {
    return {
      remoteStatus: null,
      signCode: null,
      signs: [],
      searchCompanyName: null,
      searchPersonName: null,
      searchMobile: null,
      searchEmail: null,
      showingHasSignIn: false,
      meeting: {signSetting: {
        signMeetingSteps: []
      }},
      tableLoading: true,
      saving: false,
      selectedSigns: [],
      columnsStart: [
        {
          title: '序号',
          key: 'hasSignInText',
          type: 'index',
          width: 50,
          fixed: 'left'
        },
        {
          title: '操作',
          width: 60,
          key: 'operation',
          fixed: 'left',
          render: (h, params) => {
            let elements = []
            if (params.row.signStatus === 1 && !params.row.hasSignIn) {
              elements.push(
                h('p', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.signIn(params.row.id)
                      }
                    }
                  }, '签到')
                ]
                )
              )
            }
            return h('div', elements)
          }
        },
        {
          title: '签到状态',
          key: 'hasSignInText',
          width: 130,
          fixed: 'left'
        },
        {
          title: '签到码',
          key: 'signCode',
          width: 70
        },
        {
          title: '公司名称',
          key: '公司名称',
          width: 150
        },
        {
          title: '姓名',
          key: '姓名',
          width: 80
        },
        {
          title: '职位',
          key: '职位',
          width: 80
        }
      ]
    }
  },
  computed: {
    columns () {
      let signColumns = this.getMeetingColumns()
      return [...this.columnsStart, ...signColumns]
    },
    rows () {
      return this.filterSigns(this.showingHasSignIn).map(item => {
        let jsonData = JSON.parse(item.data)
        const getDisplayValue = value => {
          if (value === null || value === undefined) {
            return ''
          }
          return String(value).trim().toLowerCase() === 'null' ? '' : value
        }
        jsonData.contactPhone = getDisplayValue(item.contactPhone)
        jsonData.contactEmail = getDisplayValue(item.contactEmail)
        return {
          ...jsonData,
          companyName: getDisplayValue(jsonData['公司名称']),
          name: getDisplayValue(jsonData['姓名']),
          mobile: getDisplayValue(jsonData['手机']),
          email: getDisplayValue(jsonData['邮箱']),
          '护照/身份证号': getDisplayValue(jsonData['护照/身份证号']) ? getDisplayValue(jsonData['护照/身份证号']) + '\t' : '',
          signInDate: this.formatDate(item.signInDate),
          hasSignInText: item.hasSignIn ? `已签到(${this.formatDate(item.signInDate)})` : '未签到',
          hasSignIn: item.hasSignIn,
          signStatus: item.signStatus,
          signCode: item.code,
          id: item.id
        }
      })
    },
    countWaitSignIn () {
      let list = this.signs.filter(item => {
        return !item.hasSignIn
      })
      return list.length
    },
    countAll () {
      return this.signs.length
    },
    countSignedIn () {
      let list = this.signs.filter(item => {
        return item.hasSignIn
      })
      return list.length
    },
    exportColumns () {
      return this.columns.filter((col, index) => {
        return index > 2
      })
    }
  },
  methods: {
    handleSelectionChange (selection) {
      this.selectedSigns = selection
    },
    filterSigns (status) {
      if (status !== undefined) {
        let filterList = this.signs.filter(item => {
          return item.hasSignIn === status
        })
        return filterList
      } else {
        return this.signs
      }
    },
    getMeetingColumns () {
      let columns = []
      this.meeting.signSetting.signMeetingSteps.forEach(step => {
        step.componentList.forEach(component => {
          if (component.signFormComponent.label !== '公司名称' &&
              component.signFormComponent.label !== '姓名' &&
              component.signFormComponent.label !== '职位') {
            columns.push({
              title: component.signFormComponent.label,
              key: component.signFormComponent.label,
              tooltip: true,
              width: 100
            })
          }
        })
      })
      columns.push({
        title: '联系人电话',
        key: 'contactPhone',
        width: 100
      })
      columns.push({
        title: '联系人邮箱',
        key: 'contactEmail',
        width: 100
      })

      return columns
    },
    exportData (type) {
      if (type === 1) {
        this.$refs.table.exportCsv({
          filename: `${this.meeting.title}_签到表`
        })
      } else if (type === 2) {
        this.$refs.table.exportCsv({
          filename: `${this.meeting.title}_签到表`,
          original: false
        })
      } else if (type === 3) {
        this.$refs.table.exportCsv({
          filename: `${this.meeting.title}_签到表`,
          columns: this.exportColumns,
          data: this.rows
        })
      }
    },
    isNumber (n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
      // return typeof n ==='number' && isFinite(n)
    },
    getStatusText (status) {
      if (status === 0) {
        return '待审核'
      } else if (status === 1) {
        return '审核通过'
      } else if (status === 2) {
        return '审核拒绝'
      }

      return ''
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
      this.saving = true
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
      this.saving = false
    },
    async signIn (signId) {
      try {
        this.beforeSave()
        let updatedSign = (await this.$http.put(`/api/admin/meetings/${this.meetingId}/signs/${signId}/signIn`)).body
        this.afterSave()
        let matchedIndex = -1
        this.signs.forEach((item, index) => {
          if (item.id === signId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.signs.splice(matchedIndex, 1, updatedSign)
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    async signInWithCode () {
      try {
        this.beforeSave()
        let updatedSign = (await this.$http.put(`/api/admin/meetings/${this.meetingId}/signs/signIn?code=${this.signCode}`)).body
        this.afterSave()
        this.signCode = null

        this.$Modal.success({
          title: '签到成功！',
          content: `<h1>${updatedSign.personName}</h1><h3>${updatedSign.attendeePhone}</h3><h3>${updatedSign.companyName}</h3>`
        })

        setTimeout(() => {
          this.$Modal.remove()
        }, 3500)

        let matchedIndex = -1
        this.signs.forEach((item, index) => {
          if (item.id === updatedSign.id) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.signs.splice(matchedIndex, 1, updatedSign)
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    async search () {
      try {
        this.$Loading.start()
        let queryStr = 'status=1&page=1&size=1000'
        if (this.searchCompanyName && this.searchCompanyName !== '') {
          queryStr += `&companyName=${this.searchCompanyName}`
        }
        if (this.searchPersonName && this.searchPersonName !== '') {
          queryStr += `&personName=${this.searchPersonName}`
        }
        if (this.searchMobile && this.searchMobile !== '') {
          queryStr += `&mobile=${this.searchMobile}`
        }
        if (this.searchEmail && this.searchEmail !== '') {
          queryStr += `&email=${this.searchEmail}`
        }
        this.signs = (await this.$http.get(`/api/admin/meetings/${this.meetingId}/signAttendees?${queryStr}`)).body.signs
        this.$Loading.finish()
      } catch (e) {
        this.afterSave(e)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/signAttendees?status=1&page=1&size=1000`)
      let meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
      next(vm => {
        vm.remoteStatus = resp.status
        vm.signs = resp.body.signs
        vm.meeting = meeting
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.signs = []
        vm.meeting = {}
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/${this.meetingId}/signAttendees?status=1&page=1&size=1000`)
      let meeting = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}`)).body

      this.remoteStatus = resp.status
      this.signs = resp.body.signs
      this.meeting = meeting

      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.signs = []
      this.meeting = {}
      next()
    }
  }
}
</script>

<style>
  .sign-list .ivu-table-cell {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .sign-list .ivu-form-item {
    margin-bottom: 0;
  }
  .sign-in-card .ivu-input.ivu-input-large {
    font-size: 32px;
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/SignIn.vue